import { useFormik } from "formik"
import * as Yup from "yup"
import { toast } from "react-toastify"
import { generateUid, TRIP_STATUS } from "utils"
import { createMemories } from "services/shortService"
import { useAppSelector } from "store"

const useShortForm = () => {
  const userDetails = useAppSelector(state => state.appLayout.userDetails) as any;

  const initialValues = {
    merchantId: userDetails?.userId || "",     //merchat uuid
    tripId: "",         //trip uuid 
    id: generateUid(),
    thumbnailUrl: "",    //thumbnail url 
    thumbnailAltText: "", 
    memoriesUrl: "",    //video url
    searchIdKey:"",     //trip
    searchId:"",        //trip
    caption: "",        //caption for the memories optional
    memoriesStatus: TRIP_STATUS.IN_REVIEW,
  }

  const validationSchema = Yup.object({
    merchantId: Yup.string().required("Merchant ID is required"),
    tripId: Yup.string().required("Trip ID is required"),
    id: Yup.string().required("ID is required"),
    thumbnailUrl: Yup.string().required("Thumbnail URL is required"),
    thumbnailAltText: Yup.string().required("Video index is required"),
    memoriesUrl: Yup.string().required("Video URL is required"),
    searchIdKey: Yup.string().required("Search ID Key is required"),
    searchId: Yup.string().required("Search ID is required"),
    caption: Yup.string(),
    memoriesStatus: Yup.string().required("Approval status is required"),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await createMemories(values)
        const successMsg = response?.data?.message || response?.message
        if (successMsg === "Item created successfully") {
          formik.resetForm()
          return response
        } else {
          throw new Error(successMsg || "Failed to create memories")
        }
      } catch (error: any) {
        console.error("[v0] Error submitting memories data:", error)
        const errorMsg = error?.response?.data?.message || error?.message || "Failed to submit memories data"
        toast.error(errorMsg)
        throw error
      } finally {
        setSubmitting(false)
      }
    },
  })

  return { formik }
}

export default useShortForm
